module.exports = new Promise((resolve, reject) => {
          const envUrl = window._env_?.CLIENTS_URL;
          const isDev = !envUrl || envUrl.startsWith('$');
          const remoteUrl = isDev ? 'http://localhost:3004' : envUrl;

          if (true && isDev) {
            console.error('[Module Federation] CLIENTS_URL not configured for production');
            reject(new Error('Clients MFE is not configured'));
            return;
          }

          const script = document.createElement('script');
          script.src = remoteUrl + '/remoteEntry.js?v=' + Date.now();
          script.onload = () => {
            resolve(window.clients);
          };
          script.onerror = () => {
            console.error('[Module Federation] Failed to load clients remote from:', remoteUrl);
            reject(new Error('Failed to load Clients MFE'));
          };
          document.head.appendChild(script);
        });